import {
    Routes,
    Route,
    BrowserRouter as Router,
    Navigate,
} from "react-router-dom";
import Dashboard from "../modules/dashboard/Dashboard";
import Patients from "../modules/patient/Patients";
import PatientLayout from "../modules/patient/PatientLayout";
import PatientOverview from "../modules/patient/PatientOverview";
import PatientProfileList from "../modules/patient/tabs/PatientProfileList";
import PatientProfile from "../modules/patient/tabs/PatientProfile";
import PatientPrimaryVisit from "../modules/patient/tabs/PatientPrimaryVisit";
import PatientRepeatVisit from "../modules/patient/tabs/PatientRepeatVisit";
import PatientAnamnesis from "../modules/patient/tabs/PatientAnamnesis";
import PatientAnketa from "../modules/patient/tabs/PatientAnketa";
import PatientAnketaSimple from "../modules/patient/tabs/PatientAnketaSimple";
import PatientSmartDiagnostics from "../modules/patient/tabs/PatientSmartDiagnostics";
import PatientRecommendations from "../modules/patient/tabs/PatientRecommendations";
import PatientListAppointments from "../modules/patient/tabs/PatientListAppointments";
import PatientPlan from "../modules/patient/tabs/PatientPlan";
import PatientPlanPrint from "../modules/patient/tabs/PatientPlanPrint";
import PatientPlanPrintOtherFormat from "../modules/patient/tabs/PatientPlanPrintOtherFormat";
import PatientSmartDiagnosticsPrint from "../modules/patient/tabs/PatientSmartDiagnosticsPrint";
import PatientUziPrint from "../modules/patient/tabs/PatientUziPrint";
import Products from "../modules/products/Products";
import ProductsProfile from "../modules/products/ProductsProfile";
import Employees from "../modules/staff/Employees";
import EmployeesProfile from "../modules/staff/EmployeesProfile";
import Contacts from "../modules/contacts/Contacts";
import ContactsProfile from "../modules/contacts/ContactsProfile";
import KnowledgeBase from "../modules/knowledge_base/KnowledgeBase";
import KnowledgeBaseArticle from "../modules/knowledge_base/KnowledgeBaseArticle";
import Accounts from "../modules/finance/Accounts";
import TransactionHistory from "../modules/finance/TransactionHistory";
import LogsHistory from "../modules/settings/logs";
import Integrations from "../modules/settings/Integrations";
import SmtpSettings from "../modules/settings/SmtpSettings";
import PatientInbody from "../modules/patient/tabs/PatientInbody";
import TreatmentPlanTemplates from "../modules/templates/TreatmentPlanTemplates";
import TreatmentPlanTemplateView from "../modules/templates/TreatmentPlanTemplateView";
import TreatmentRecommend from "../modules/templates/TreatmentRecommend";
import TreatmentRecommendView from "../modules/templates/TreatmentRecommendView";
import Schedule from "../modules/schedule/Schedule";
import PatientYc from "../modules/patient/PatientYc";
import Warehouse from "../modules/warehouse/Warehouse";
import WarehouseUnits from "../modules/warehouse/WarehouseUnits";
import WarehouseLogs from "../modules/warehouse/WarehouseLogs";
import InstructionTreatmentPlan from "../modules/instructions/InstructionTreatmentPlan";
import InstructionAppointmentList from "../modules/instructions/InstructionAppointmentList";
import InstructionServices from "../modules/instructions/InstructionServices";
import InstructionRecommendations from "../modules/instructions/InstructionRecommendations";
import PatientPlanList from "../modules/patient/tabs/PatientPlanList";
import PatientDynamics from "../modules/patient/tabs/PatientDynamics";
import PatientDiagnostics from "../modules/patient/tabs/PatientDiagnostics";
import PatientUziForm from "../modules/patient/tabs/PatientUziForm";
import PatientAnalyses from "../modules/patient/tabs/PatientAnalyses";
import PatientAnalysesAI from "../modules/patient/tabs/PatientAnalysesAI";
import PatientAgreements from "../modules/patient/tabs/PatientAgreements";
import PatientProfilePrint from "../modules/patient/tabs/PatientProfilePrint";







function Routing({ client, module, paid, patients }) {
    const patients2 = [];

    return (
        <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/schedule/" element={<Schedule />} />
            <Route path="/patient_yc/:idYc" element={<PatientYc />} />
            <Route path="/patient/:patientId/plan/:planId/print" element={<PatientPlanPrint />} />
            <Route path="/patient/:patientId/plan/:planId/print-other" element={<PatientPlanPrintOtherFormat />} />
            <Route path="/patient/:patientId/plan/:planId/print-smart-diagnostics" element={<PatientSmartDiagnosticsPrint />} />
            <Route path="/print/uzi" element={<PatientUziPrint />} />
            <Route path="/patient/:patientId/diagnostics/uzi/:diagnosticsId/print" element={<PatientUziPrint />} />
            <Route path="/patient/:patientId/profile/print" element={<PatientProfilePrint />} />
            <Route path="/services" element={<Products />} />
            <Route path="/services/:id" element={<ProductsProfile />}></Route>
            <Route
                path="/patient/:patientId"
                element={<PatientLayout patients={patients} />}>
                <Route
                    index
                    element={<Navigate to="overview" replace patients={patients} />}
                />
                <Route path="contacts" element={<Navigate to="overview" replace />} />
                <Route path="overview" element={<PatientOverview />} />
                <Route path="profile" element={<PatientProfileList />} />
                <Route path="profile/old" element={<PatientProfile />} />
                <Route path="profile/primary/:docId" element={<PatientPrimaryVisit />} />
                <Route path="profile/repeat/:docId" element={<PatientRepeatVisit />} />
                <Route path="profile/anamnesis/:docId" element={<PatientAnamnesis />} />
                <Route path="profile/anketa/:docId" element={<PatientAnketa />} />
                <Route path="profile/anketa-simple/:docId" element={<PatientAnketaSimple />} />
                <Route path="profile/smart-diagnostics/:docId" element={<PatientSmartDiagnostics />} />
                <Route path="inbody" element={<PatientInbody />} />
                <Route path="dynamics" element={<PatientDynamics/>} />
                <Route path="diagnostics" element={<PatientDiagnostics />} />
                <Route path="diagnostics/uzi" element={<PatientUziForm />} />
                <Route path="diagnostics/uzi/:diagnosticsId" element={<PatientUziForm />} />
                <Route path="documents" element={<PatientAgreements />} />
                <Route path="analyses" element={<PatientAnalyses />} />
                <Route path="ai-analyses" element={<PatientAnalysesAI />} />
                <Route path="plan" element={<PatientPlanList />} />
                <Route path="plan/:planId" element={<PatientPlan />} />
                <Route path="plan/:planId/appointments" element={<PatientListAppointments />} />
                <Route path="plan/:planId/recommendations" element={<PatientRecommendations />} />
                <Route path="recommendations" element={<PatientRecommendations />} />
                <Route path="appointments" element={<PatientListAppointments />} />
                <Route path="payments" element={<Navigate to="profile" replace />} />
                <Route path="history" element={<Navigate to="profile" replace />} />
            </Route>
            <Route path="/patient/" element={<Patients client={client} patients={patients2} />} />
            <Route path="/staff" element={<Employees />} />
            <Route path="/staff/:id" element={<EmployeesProfile />}></Route>
            <Route path="/warehouse/" element={<Warehouse />} />
            <Route path="/warehouse/units/" element={<WarehouseUnits />} />
            <Route path="/warehouse/logs/" element={<WarehouseLogs />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/contacts/:id" element={<ContactsProfile />} />
            <Route path="/knowledge_base" element={<KnowledgeBase />} />
            <Route path="/knowledge_base/:id" element={<KnowledgeBaseArticle />} />
            <Route
                path="/instructions/plan/"
                element={<InstructionTreatmentPlan />}
            />
            <Route
                path="/instructions/appointments/"
                element={<InstructionAppointmentList />}
            />
            <Route
                path="/instructions/services/"
                element={<InstructionServices />}
            />
            <Route
                path="/instructions/recommendations/"
                element={<InstructionRecommendations />}
            />
            <Route path="/finance/accounts" element={<Accounts />} />
            <Route
                path="/finance/transaction_history"
                element={<TransactionHistory />}
            />


            <Route
                path="/settings/logs/"
                element={<LogsHistory />}
            />
            <Route
                path="/settings/integrations/"
                element={<Integrations />}
            />
            <Route
                path="/settings/smtp/"
                element={<SmtpSettings />}
            />
            <Route
                path="/templates/treatment_plans"
                element={<TreatmentPlanTemplates />}
            />
            <Route
                path="/templates/treatment_plans/:id"
                element={<TreatmentPlanTemplateView />}
            />

            <Route
                path="/templates/recommendation"
                element={<TreatmentRecommend />}
            />
            <Route
                path="/templates/recommendation/:id"
                element={<TreatmentRecommendView />}
            />
        </Routes>
    );
}

export default Routing;
